export const generateTempFileName = (videoId: string, fileExt: string) => {
  return (
    videoId +
    '_' +
    (Math.random() + 1).toString(36).substring(2) +
    '.' +
    fileExt
  );
};
